<template>
  <div class="formSetting">
    <el-collapse v-model="activeNames" accordion>
      <el-collapse-item title="内容样式" name="1">
        <el-alert title="添加导航(最少2个，最多5个)" type="success" :closable="false">
        </el-alert>
        <el-card shadow="hover" v-for="(item, index) in data.footerList" :key="index">
          <div class="closeIcon" @click="handleRemove(item, index)">
            <i class="el-icon-close"></i>
          </div>
          <div class="footerSetBox">
            <div>
              <el-input v-model="item.title" placeholder="请输入内容" size="small" maxlength="4" show-word-limit></el-input>
              <el-dropdown  @command="handleLinkItem">
                <span class="el-dropdown-link">
                  {{ item.link }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(link, idx) in data.linkList" :key="idx" :command="`${link.title}#${link.page}?${index}`">{{ link.title }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="imgBox">
              <div class="imgItem">
                <div @click="handleUpimg('默认', index)">
                  <img :src="item.src" alt="">
                </div>
                <p>默认</p>
              </div>
              <div class="imgItem">
                <div @click="handleUpimg('高亮', index)">
                  <img :src="item.active" alt="">
                </div>
                <p>高亮</p>
              </div>
            </div>
          </div>
        </el-card>
        <el-button type="primary" style="width: 100%;" size="small" @click="handleAdd">添加导航</el-button>
      </el-collapse-item>
      <el-collapse-item title="组件样式" name="2">
        <ul class="settingUl">
          <li>
            <span>文字颜色</span>
            <el-color-picker v-model="data.textColor"></el-color-picker>
          </li>
          <li>
            <span>选中颜色</span>
            <el-color-picker v-model="data.xzColor"></el-color-picker>
          </li>
          <li>
            <span>背景颜色</span>
            <el-color-picker v-model="data.bjColor"></el-color-picker>
          </li>
        </ul>
      </el-collapse-item>
    </el-collapse>

    <imgPre v-if="uploadShow" :dialogVisible="uploadShow" @checkImg="handleImg" @onClose="uploadShow = false" />
  </div>
</template>
<script>
import home from '../assets/footer/home.png'
import infohome from '../assets/footer/infoHome.png'
import imgPre from '../components/uploadImg/imgPre'
export default {
  name: 'footToolbarSetting',
  components: { imgPre },
  props: {
    data: Object
  },
  data () {
    return {
      activeNames: ['1'],
      btnVal: '',
      value1: true,
      msgValue: false,
      uploadShow: false,
      idx: 0,
      info: '默认'
    }
  },
  methods: {
    handleRemove (item, index) {
      if (index === 0) {
        this.$message({
          message: '首页不能删除',
          type: 'warning'
        })
        return
      }
      console.log(this.data.footerList.length)
      if (this.data.footerList.length < 3) {
        this.$message({
          message: '底部选项卡不能少于2个',
          type: 'warning'
        })
        return
      }
      this.data.footerList.splice(index, 1)
    },
    handleAdd () {
      if (this.data.footerList.length > 4) {
        this.$message({
          message: '底部选项卡不能大于5个',
          type: 'warning'
        })
        return
      }
      this.data.footerList.push({
        src: infohome,
        title: '导航',
        link: '导航',
        active: home
      })
    },
    handleUpimg (text, index) {
      this.uploadShow = true
      this.idx = index
      this.info = text
    },
    handleImg (item) {
      console.log('回传图片', item)
      if (this.info === '默认') {
        this.data.footerList[this.idx].src = item.url
      } else {
        this.data.footerList[this.idx].active = item.url
      }
      this.uploadShow = false
    },
    handleLinkItem (command) {
      const idx = command.indexOf('?')
      const idx1 = command.indexOf('#')
      var before = command.substring(0, idx)
      var after = command.substring(idx + 1)
      const pagetit = before.substring(0, idx1)
      const page = before.substring(idx1 + 1)

      this.data.footerList[Number(after)].link = pagetit
      this.data.footerList[Number(after)].page = page
    }
  },
  mounted () {
    console.log('这是底部栏设置页面', this.data)
  }
}
</script>

<style scoped>
.el-card {
  margin-bottom: 10px;
  position: relative;
  overflow: initial;
}

.closeIcon {
  position: absolute;
  top: -8px;
  right: -8px;
}

.closeIcon .el-icon-close {
  font-size: 18px;
}

.footerSetBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.imgBox {
  display: flex;
  gap: 8px;
}

.imgBox .imgItem div {
  background: #f5f5f5;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.imgBox .imgItem img {
  max-width: 30px;
  max-height: 30px;
}

.imgBox .imgItem p {
  text-align: center;
}

/deep/ .el-collapse-item__content {
  margin: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/footToolbarSetting.vue